import React from 'react'
import { intl } from 'lang/intl'

import { TtButton, TtIcon, TtTooltip } from '@23/ui-react'

import { useOpenSecondCamCode } from '../../SecondCamModal/SecondCamModal'

export const SecondCam = () => {
  const openSecondCamCode = useOpenSecondCamCode()

  const getTooltipContent = () => {
    return intl.formatMessage({ defaultMessage: 'Add a 2ndCam' })
  }

  const getAriaLabel = () => {
    return intl.formatMessage({ defaultMessage: 'Add a second camera' })
  }

  return (
    <TtTooltip content={getTooltipContent()} placement="left" distance={16}>
      <TtButton
        circle
        aria-label={getAriaLabel()}
        onClick={openSecondCamCode}
        color="secondary"
      >
        <TtIcon library="one/webinars" name="2nd-cam" />
      </TtButton>
    </TtTooltip>
  )
}
